/**
 * HistoryView — task archive.
 * Per app-codex: surface "history.archive". Behaviour: history.view.
 * Tasks are auto-archived 30 days after `done_at` per app-codex/state.md.
 * Dev mode: uses devDb.
 */
import { useEffect, useState } from 'react'
import { supabase } from '../supabase'
import { devDb } from '../devMode'
import type { DbTask } from '../db'
import { History as HistoryIcon, Sparkles } from 'lucide-react'
import { useApp } from '../store'

export function HistoryView() {
  const { dev } = useApp()
  const [tasks, setTasks] = useState<DbTask[]>([])

  useEffect(() => {
    if (dev) {
      devDb.history.list().then(({ data }) => setTasks(data ?? []))
    } else {
      supabase
        .from('tasks')
        .select('*')
        .eq('status', 'done')
        .order('done_at', { ascending: false })
        .limit(100)
        .then(({ data }) => setTasks(data ?? []))
    }
  }, [dev])

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-2xl font-semibold text-skin-text">History</h1>
        <p className="text-slate-500 mt-1">A gentle record of what we've done.</p>
      </header>

      <div className="space-y-2">
        {tasks.map((t) => (
          <div key={t.id} className="bg-white border border-slate-200 rounded-xl p-3 flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center">
              <HistoryIcon className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-skin-text truncate">{t.title}</h3>
              <p className="text-xs text-slate-500 flex items-center gap-1.5">
                {t.done_at && (
                  <span>{new Date(t.done_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                )}
                <span>·</span>
                <span className="flex items-center gap-0.5"><Sparkles className="w-3 h-3 text-reward-500" /> {t.ep} EP</span>
              </p>
            </div>
          </div>
        ))}
        {tasks.length === 0 && (
          <div className="text-center text-slate-400 py-12">No completed tasks yet.</div>
        )}
      </div>
    </div>
  )
}
